(() => {
  const CHOSAE_COLOR_IMAGES = {
    'gray white': [
      ['01_gray_white_studio', '06_gray_white_lifestyle_ankle']
    ],

    'black blue': [
      ['02_black_blue_studio', '07_black_blue_lifestyle_wrist']
    ],

    'pink': [
      ['03_pink_studio', '08_pink_lifestyle_knee'],
      ['chosae-lumbar-cushion-pink-studio', 'chosae-lumbar-cushion-pink-lifestyle']
    ],

    'white': [
      ['04_white_studio', '09_white_lifestyle_elbow']
    ],

    'black': [
      ['05_black_studio', '10_black_lifestyle_ankle'],
      ['03_cojin_lumbar_estudio', '04_cojin_lumbar_lifestyle']
    ],

    'grey': [
      ['01_almohada_cervical_estudio', '02_almohada_cervical_lifestyle']
    ],

    'purple': [
      ['chosae-contour-pillow-purple-studio', 'chosae-contour-pillow-purple-lifestyle']
    ],

    'green': [
      ['chosae-contour-pillow-green-studio', 'chosae-contour-pillow-green-lifestyle']
    ],

    'blue': [
      ['chosae-lumbar-cushion-blue-studio', 'chosae-lumbar-cushion-blue-lifestyle'],
      ['chosae-neck-support-blue-studio', 'chosae-neck-support-blue-lifestyle']
    ],

    'brown': [
      ['07_estirador_cuello_estudio', '08_estirador_cuello_lifestyle']
    ]
  };

  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase();

  /**
   * Encuentra el color actualmente seleccionado
   * dentro del variant-picker de Horizon.
   */
  function getSelectedColor(variantPicker) {
    // Botones / swatches / radios
    const checkedInputs = variantPicker.querySelectorAll(
      'input[data-option-name]:checked'
    );

    for (const input of checkedInputs) {
      const value = normalize(input.value);

      if (CHOSAE_COLOR_IMAGES[value]) {
        return value;
      }
    }

    // Dropdowns
    const selects = variantPicker.querySelectorAll(
      'select.variant-option__select'
    );

    for (const select of selects) {
      const value = normalize(select.value);

      if (CHOSAE_COLOR_IMAGES[value]) {
        return value;
      }
    }

    return null;
  }

  /**
   * Obtiene src, srcset, currentSrc y alt
   * para identificar el nombre original de Shopify.
   */
  function getMediaText(element) {
    const pieces = [];

    element.querySelectorAll('img').forEach((img) => {
      pieces.push(
        img.currentSrc || '',
        img.src || '',
        img.srcset || '',
        img.alt || ''
      );
    });

    element.querySelectorAll('source').forEach((source) => {
      pieces.push(
        source.src || '',
        source.srcset || ''
      );
    });

    return pieces.join(' ').toLowerCase();
  }

  function mediaMatches(element, allowedFiles) {
    const mediaText = getMediaText(element);

    return allowedFiles.some((filename) =>
      mediaText.includes(filename)
    );
  }

  /**
   * Actualiza thumbnails, dots y counter
   * del slideshow de Horizon.
   */
  function updateControls(slideshow, visibleMask) {
    const visibleCount =
      visibleMask.filter(Boolean).length;

    slideshow
      .querySelectorAll('slideshow-controls')
      .forEach((controls) => {

        // THUMBNAILS
        const thumbnails = Array.from(
          controls.querySelectorAll(
            '.slideshow-controls__thumbnails .slideshow-control'
          )
        );

        if (thumbnails.length === visibleMask.length) {
          thumbnails.forEach((thumbnail, index) => {
            thumbnail.hidden = !visibleMask[index];
          });
        }

        // DOTS
        const dots = Array.from(
          controls.querySelectorAll(
            '.slideshow-controls__dots > li'
          )
        );

        if (dots.length === visibleMask.length) {
          dots.forEach((dot, index) => {
            dot.hidden = !visibleMask[index];
          });
        }

        // COUNTER: 1 / 2 en vez de 1 / 10
        const counter = controls.querySelector(
          '.slideshow-controls__counter'
        );

        if (counter) {
          const slash = counter.querySelector('.slash');

          if (slash) {
            let node = slash.nextSibling;

            while (node) {
              if (node.nodeType === Node.TEXT_NODE) {
                node.textContent = visibleCount;
                break;
              }

              node = node.nextSibling;
            }
          }
        }
      });
  }

  /**
   * Encuentra, entre los varios grupos de archivos posibles
   * para un color (puede haber más de un producto usando el
   * mismo nombre de color, ej. "black" o "pink"), el grupo que
   * realmente existe dentro de ESTA galería.
   */
  function resolveAllowedFiles(gallery, color) {
    const candidateGroups = CHOSAE_COLOR_IMAGES[color];

    if (!candidateGroups) return null;

    const galleryText = getMediaText(gallery);

    for (const group of candidateGroups) {
      const matches = group.every((filename) =>
        galleryText.includes(filename)
      );

      if (matches) return group;
    }

    return null;
  }

  /**
   * Filtra la galería Horizon.
   */
  function filterGallery(gallery, color) {
    /*
     * SEGURIDAD:
     * solo activamos el filtro si encontramos
     * las imágenes CHOSAE dentro de esta galería.
     *
     * Así no afecta otros productos que tengan,
     * por ejemplo, una variante llamada "Black" o "Pink"
     * que pertenezca a otro producto distinto.
     */
    const allowedFiles = resolveAllowedFiles(gallery, color);

    if (!allowedFiles) return;

    /*
     * -----------------------------
     * DESKTOP GRID
     * -----------------------------
     */
    const gridItems = gallery.querySelectorAll(
        '.media-gallery__grid > .product-media-container'
    );

    gridItems.forEach((item) => {
        const visible =
            mediaMatches(item, allowedFiles);

        item.hidden = !visible;

        // Horizon fuerza display:flex en desktop grid.
        // El estilo inline asegura que las imágenes no seleccionadas
        // realmente desaparezcan.
        item.style.display = visible ? '' : 'none';
    });
    /*
     * -----------------------------
     * HORIZON SLIDESHOW / MOBILE
     * -----------------------------
     */
    const slideshows =
      gallery.querySelectorAll('slideshow-component');

    slideshows.forEach((slideshow) => {
      /*
       * Evitamos capturar slideshow-slide
       * pertenecientes a componentes anidados.
       */
      const slides = Array.from(
        slideshow.querySelectorAll('slideshow-slide')
      ).filter(
        (slide) =>
          slide.closest('slideshow-component') === slideshow
      );

      if (!slides.length) return;

      const visibleMask = slides.map((slide) =>
        mediaMatches(slide, allowedFiles)
      );

      /*
       * Si este slideshow no contiene
       * las imágenes del producto, no tocarlo.
       */
      if (!visibleMask.some(Boolean)) return;

      slides.forEach((slide, index) => {
        const visible = visibleMask[index];

        slide.hidden = !visible;

        if (visible) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute(
            'aria-hidden',
            'true'
          );
        }
      });

      updateControls(
        slideshow,
        visibleMask
      );

      /*
       * Llevar automáticamente el carrusel
       * a la primera foto del color seleccionado.
       */
      const firstVisible =
        slides.find(
          (_, index) => visibleMask[index]
        );

      if (!firstVisible) return;

      const slideId =
        firstVisible.getAttribute('slide-id');

      if (!slideId) return;

      customElements
        .whenDefined('slideshow-component')
        .then(() => {
          requestAnimationFrame(() => {
            if (
              typeof slideshow.select ===
              'function'
            ) {
              slideshow.select(
                { id: slideId },
                undefined,
                { animate: false }
              );
            }
          });
        });
    });
  }

  /**
   * Aplica filtro al producto correspondiente.
   */
  function applyToPicker(variantPicker) {
    const selectedColor =
      getSelectedColor(variantPicker);

    if (!selectedColor) return;

    /*
     * Normalmente product-information está
     * dentro de su propia Shopify section.
     */
    const section =
      variantPicker.closest('.shopify-section') ||
      variantPicker.closest('section') ||
      document;

    const gallery =
      section.querySelector('media-gallery');

    if (!gallery) return;

    filterGallery(
      gallery,
      selectedColor
    );
  }

  function applyAll() {
    document
      .querySelectorAll('variant-picker')
      .forEach(applyToPicker);
  }

  /*
   * Primera carga.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      applyAll
    );
  } else {
    applyAll();
  }

  /*
   * Cambio de variante Horizon.
   */
  document.addEventListener(
    'change',
    (event) => {
      if (
        !event.target.closest(
          'variant-picker'
        )
      ) {
        return;
      }

      /*
       * Primera ejecución inmediata.
       */
      requestAnimationFrame(applyAll);

      /*
       * Horizon puede actualizar/morphear
       * partes del producto después del cambio.
       */
      setTimeout(applyAll, 100);
      setTimeout(applyAll, 300);
    },
    true
  );

  /*
   * Shopify Theme Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    applyAll
  );

  /*
   * Si Horizon reemplaza dinámicamente
   * gallery/picker, volvemos a aplicar.
   */
  let observerScheduled = false;

  const observer =
    new MutationObserver((mutations) => {
      const relevant =
        mutations.some((mutation) =>
          Array.from(
            mutation.addedNodes
          ).some((node) => {
            if (
              node.nodeType !==
              Node.ELEMENT_NODE
            ) {
              return false;
            }

            return (
              node.matches?.(
                'media-gallery, variant-picker'
              ) ||
              node.querySelector?.(
                'media-gallery, variant-picker'
              )
            );
          })
        );

      if (
        !relevant ||
        observerScheduled
      ) {
        return;
      }

      observerScheduled = true;

      requestAnimationFrame(() => {
        observerScheduled = false;
        applyAll();
      });
    });

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
})();